import React from "react";
import "./styles/style.css";

function index() {
  return (
    <div className="footer">
      <div className="footer__copyright">
        Spark Tech AI © 2023{" "}
      </div>
      <div className="footer__policy">
        <a className="footer_link" href="https://docs.google.com/document/d/1f8DnzVJNWxKmBiSVusqHpClz39HdspePajA21_yLfs4/edit?usp=sharing"><p>Privacy Policy</p></a>
        <a className="footer_link" href="https://docs.google.com/document/d/1RHNfeYbPjtBrkljhkWM4YVyDaD73srtiO62EHnV5sVg/edit?usp=sharing"><p>Terms of Use</p></a>
      </div>
      <div className="footer__socials">
        <svg
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.179199"
            y="0.930176"
            width="44"
            height="44"
            rx="22"
            fill="#CB916E"
          />
          <g clip-path="url(#clip0_107_7782)">
            <path
              d="M29.1792 14.9302H15.1792C14.3835 14.9302 13.6205 15.2462 13.0579 15.8089C12.4953 16.3715 12.1792 17.1345 12.1792 17.9302V27.9302C12.1792 28.7258 12.4953 29.4889 13.0579 30.0515C13.6205 30.6141 14.3835 30.9302 15.1792 30.9302H29.1792C29.9748 30.9302 30.7379 30.6141 31.3005 30.0515C31.8631 29.4889 32.1792 28.7258 32.1792 27.9302V17.9302C32.1792 17.1345 31.8631 16.3715 31.3005 15.8089C30.7379 15.2462 29.9748 14.9302 29.1792 14.9302ZM29.1792 16.9302L22.6792 21.4002C22.5272 21.4879 22.3547 21.5342 22.1792 21.5342C22.0037 21.5342 21.8312 21.4879 21.6792 21.4002L15.1792 16.9302H29.1792Z"
              fill="#F6ECE6"
            />
          </g>
          <defs>
            <clipPath id="clip0_107_7782">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(10.1792 10.9302)"
              />
            </clipPath>
          </defs>
        </svg>
        <svg
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.179199"
            y="0.930176"
            width="43.9998"
            height="43.9999"
            rx="21.9999"
            fill="#CB916E"
          />
          <path
            d="M17.2093 11.0141C15.9325 11.0743 15.0606 11.2781 14.2983 11.5776C13.5095 11.8851 12.8408 12.2976 12.1755 12.9653C11.5103 13.633 11.1006 14.3021 10.7953 15.0922C10.4999 15.8561 10.2997 16.7287 10.2433 18.0063C10.1869 19.2838 10.1744 19.6944 10.1807 22.9531C10.1869 26.2119 10.2013 26.6203 10.2632 27.9005C10.3242 29.1771 10.5272 30.0487 10.8267 30.8112C11.1347 31.6001 11.5467 32.2685 12.2147 32.934C12.8826 33.5995 13.5512 34.0083 14.3432 34.314C15.1064 34.609 15.9793 34.8101 17.2566 34.866C18.5339 34.9219 18.945 34.9349 22.2027 34.9287C25.4605 34.9224 25.8707 34.908 27.1506 34.8473C28.4305 34.7866 29.2976 34.5821 30.0603 34.284C30.8492 33.9754 31.5181 33.564 32.1831 32.8959C32.8482 32.2277 33.2576 31.5581 33.5627 30.7675C33.8583 30.0043 34.0592 29.1315 34.1147 27.8551C34.1706 26.5743 34.1838 26.1653 34.1775 22.9071C34.1713 19.6488 34.1567 19.2403 34.0959 17.9607C34.0352 16.681 33.8319 15.8119 33.5327 15.049C33.2243 14.2601 32.8127 13.5922 32.145 12.9262C31.4773 12.2602 30.8072 11.851 30.0169 11.5467C29.2532 11.2512 28.3808 11.0499 27.1035 10.9947C25.8263 10.9395 25.4151 10.9253 22.1562 10.9315C18.8972 10.9378 18.4892 10.9517 17.2093 11.0141ZM17.3495 32.7072C16.1795 32.6563 15.5442 32.4619 15.1208 32.2992C14.5602 32.0832 14.1608 31.8221 13.7389 31.4043C13.317 30.9864 13.0578 30.5856 12.8389 30.0262C12.6745 29.6028 12.4765 28.9683 12.4218 27.7983C12.3623 26.5337 12.3498 26.154 12.3428 22.9503C12.3359 19.7465 12.3481 19.3673 12.4035 18.1023C12.4535 16.9332 12.6491 16.2972 12.8115 15.8741C13.0275 15.3127 13.2877 14.9141 13.7065 14.4924C14.1253 14.0707 14.5249 13.8111 15.0848 13.5922C15.5077 13.4271 16.1423 13.2307 17.3118 13.1751C18.5773 13.1151 18.9565 13.1031 22.1598 13.0961C25.3631 13.0891 25.7432 13.1011 27.0092 13.1568C28.1783 13.2077 28.8145 13.4014 29.2371 13.5648C29.798 13.7808 30.1971 14.0403 30.6188 14.4598C31.0405 14.8793 31.3004 15.2775 31.5193 15.8386C31.6847 16.2603 31.881 16.8946 31.9362 18.0648C31.9964 19.3303 32.0101 19.7098 32.0159 22.9128C32.0216 26.1159 32.0103 26.4963 31.9549 27.7608C31.9038 28.9308 31.7099 29.5663 31.5469 29.9902C31.3309 30.5506 31.0705 30.9502 30.6515 31.3716C30.2324 31.7931 29.8333 32.0527 29.2731 32.2716C28.8507 32.4365 28.2155 32.6333 27.0469 32.689C25.7814 32.7485 25.4022 32.761 22.1977 32.7679C18.9932 32.7749 18.6152 32.7619 17.3497 32.7072M27.1321 16.5166C27.1326 16.8014 27.2175 17.0797 27.3761 17.3162C27.5348 17.5528 27.76 17.737 28.0234 17.8455C28.2867 17.9541 28.5763 17.9821 28.8556 17.926C29.1348 17.8699 29.3912 17.7323 29.5922 17.5305C29.7932 17.3288 29.9299 17.0719 29.985 16.7925C30.04 16.513 30.0109 16.2235 29.9014 15.9606C29.7919 15.6976 29.6069 15.4731 29.3698 15.3153C29.1326 15.1575 28.854 15.0736 28.5692 15.0742C28.1874 15.0749 27.8215 15.2273 27.552 15.4978C27.2825 15.7683 27.1315 16.1348 27.1321 16.5166ZM16.0177 22.9421C16.0244 26.3453 18.7883 29.0979 22.1907 29.0914C25.5932 29.0849 28.3477 26.3213 28.3412 22.9181C28.3347 19.5149 25.5702 16.7616 22.1672 16.7683C18.7643 16.7751 16.0112 19.5394 16.0177 22.9421ZM18.1791 22.9378C18.1776 22.1466 18.4106 21.3728 18.8489 20.7141C19.2871 20.0555 19.9108 19.5415 20.6411 19.2373C21.3715 18.9331 22.1756 18.8523 22.9518 19.0051C23.7281 19.1579 24.4416 19.5375 25.0021 20.0958C25.5626 20.6541 25.945 21.3661 26.1009 22.1417C26.2568 22.9174 26.1791 23.7218 25.8778 24.4533C25.5765 25.1848 25.0651 25.8106 24.4081 26.2514C23.7512 26.6922 22.9783 26.9284 22.1871 26.9299C21.6618 26.931 21.1414 26.8287 20.6557 26.6286C20.17 26.4286 19.7284 26.1348 19.3562 25.7641C18.984 25.3934 18.6885 24.953 18.4865 24.468C18.2846 23.9831 18.1801 23.4631 18.1791 22.9378Z"
            fill="#F6ECE6"
          />
        </svg>
        <svg
          width="44"
          height="45"
          viewBox="0 0 44 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.178955"
            y="0.930176"
            width="43.821"
            height="44"
            rx="21.9105"
            fill="#CB916E"
          />
          <path
            d="M31.5612 18.0614C31.5757 18.2718 31.5757 18.4822 31.5757 18.6945C31.5757 25.1648 26.6596 32.627 17.6702 32.627V32.6231C15.0148 32.627 12.4144 31.8649 10.179 30.4279C10.5651 30.4744 10.9531 30.4977 11.3422 30.4987C13.5428 30.5006 15.6806 29.7608 17.4119 28.3985C15.3206 28.3587 13.4867 26.9925 12.8461 24.998C13.5786 25.1396 14.3335 25.1105 15.0525 24.9137C12.7725 24.4521 11.1322 22.445 11.1322 20.1141C11.1322 20.0927 11.1322 20.0724 11.1322 20.052C11.8115 20.4311 12.5722 20.6415 13.3502 20.6648C11.2028 19.2269 10.5409 16.3646 11.8377 14.1267C14.319 17.1858 17.9799 19.0455 21.9099 19.2424C21.5161 17.5417 22.0541 15.7595 23.3238 14.564C25.2922 12.7101 28.388 12.8051 30.2383 14.7763C31.3328 14.5601 32.3819 14.1577 33.3419 13.5876C32.977 14.721 32.2135 15.6839 31.1935 16.2957C32.1622 16.1813 33.1086 15.9214 33.9999 15.5249C33.3438 16.51 32.5173 17.3681 31.5612 18.0614Z"
            fill="#F6ECE6"
          />
        </svg>
      </div>
    </div>
  );
}

export default index;
